
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/urbanplanen",
      function () {
        return require("private-next-pages/archive/urbanplanen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/urbanplanen"])
      });
    }
  